// import { motion, AnimatePresence, useAnimation } from "framer-motion";
import { useSnapshot } from "valtio";
import { state } from "../store.js";
import "./styles.css";
import { useEffect, useLayoutEffect, useMemo, useRef } from "react";
import { SplitText } from "gsap/SplitText";
// import SplitType from "split-type";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
// import useSound from "use-sound";

const tl = gsap.timeline({ paused: true });

gsap.registerPlugin(SplitText);

export default function IntroOverlay() {
  const { intro, finishedIntro, finishedMainLoading } = useSnapshot(state);
  // Read persisted next-start quality from localStorage for the notice text
  const qualityLabel = useMemo(() => {
    try {
      const saved =
        typeof localStorage !== "undefined" &&
        localStorage.getItem("qualitySettings");
      const value = saved || "balanced";
      return value.charAt(0).toUpperCase() + value.slice(1);
    } catch (err) {
      return "Balanced";
    }
  }, []);
  const boxRef = useRef();
  const buttonAudio = useRef(null);
  const introButtonRef = useRef();

  buttonAudio.current = document.getElementById("buttonAudio");

  useGSAP(
    () => {
      // Wait for the main title element to be available
      const titleElement = boxRef.current?.querySelector(".main-title");
      const subTitleElement = boxRef.current?.querySelector(".sub-title");
      if (!titleElement || !subTitleElement) return;

      const title = SplitText.create(".main-title", { type: "words,chars" });
      const subTitleMarine = SplitText.create(".sub-title", {
        type: "words,chars",
      });
      const charsTitle = title.chars;
      const charsSubTitle = subTitleMarine.chars;

      gsap.set(".main-title", { perspective: 400 });
      gsap.set(".sub-title", { perspective: 400 });
      gsap.set(".intro-button", { pointerEvents: "none", opacity: 0 });

      tl.from(
        charsTitle,
        {
          duration: 1,
          opacity: 0,
          // y: -20,
          ease: "power1.inOut",
          stagger: 0.1,
        },
        "<"
      )
        .from(
          charsSubTitle,
          {
            duration: 1,
            opacity: 0,
            // y: 120,
            ease: "power1.inOut",
            stagger: 0.2,
          },
          "<"
        )
        .fromTo(
          ".intro-loading",
          { opacity: 0, y: 30 },
          {
            y: 0,
            opacity: 0.7,
            ease: "power1.out",
            duration: 0.4,
            onComplete: () => {
              gsap.set(".intro-button", { pointerEvents: "auto" });
            },
          },
          "-=1.2"
        )
        .fromTo(
          ".intro-button",
          { opacity: 0 },
          { opacity: 1, duration: 0.4 },
          "<"
        )
        .fromTo(
          ".button-performance",
          { opacity: 0, y: 30 },
          {
            y: 0,
            opacity: 0.7,
            ease: "power1.out",
            duration: 0.2,
          },
          "<"
        );
    },
    { scope: boxRef, dependencies: [finishedMainLoading] }
  );

  useEffect(() => {
    if (finishedMainLoading) {
      tl.play();
    }
  }, [finishedMainLoading]);

  function handleClick() {
    if (buttonAudio.current) buttonAudio.current.click();
    state.hoveredIntro = 1;
    state.intro = false;
    introButtonRef.current.style.pointerEvents = "none";

    gsap.to(".intro-container", {
      opacity: 0,
      ease: "power0.out",
      duration: 0.6,
    });
  }

  return (
    // <AnimatePresence>
    <>
      {!finishedIntro && (
        <div className="intro-container" ref={boxRef}>
          {/* {finishedMainLoading && <ClassicsTitle />} */}

          <h1 className="main-title">DOPPLE</h1>
          <h2 className="sub-title">MARINE</h2>

          <div className="intro-loading">
            <button
              className="intro-button"
              ref={introButtonRef}
              onClick={() => {
                // Do not override quality here; use whatever is already set/persisted
                handleClick();
              }}
              // onPointerOver={() => {
              //   state.hoveredIntro = 1;
              // }}
              // onPointerOut={() => (state.hoveredIntro = 0)}
            >
              START
            </button>
            {/* Small notice indicating which quality will be used on enter */}
          </div>

          <button
            onClick={() => {
              // Persist performance mode selection without changing current session state
              // try {
              //   localStorage.setItem("qualitySettings", "performance");
              // } catch (err) {
              //   // Ignore storage errors (quota/privacy mode)
              // }
              localStorage.setItem("qualitySettings", "performance");
              state.qualitySettings = "performance";
              handleClick();
            }}
            className="button-performance"
          >
            FORCE PERFORMANCE MODE
            <div
              style={{
                fontSize: "8px",
                marginTop: "10px",
                opacity: 0.75,
                fontWeight: "bold",
                textTransform: "uppercase",
              }}
            >
              currently set to {qualityLabel} quality
            </div>
          </button>
        </div>
      )}
    </>
    // </AnimatePresence>
  );
}

function ClassicsTitle() {
  const ref = useRef();

  useEffect(() => {
    let paths = ref.current.querySelectorAll("svg path");
    const speed = 65;

    paths.forEach((item, index) => {
      let pathLength = item.getTotalLength();

      item.setAttribute("stroke-dasharray", pathLength);
      item.setAttribute("stroke-dashoffset", pathLength);

      if (index === 0) {
        item.innerHTML =
          "<animate id='" +
          index +
          "' attributeName='stroke-dashoffset' begin='2s' dur='" +
          pathLength / speed +
          "s' to='0' fill='freeze' />";
      } else {
        item.innerHTML =
          "<animate id='" +
          index +
          "' attributeName='stroke-dashoffset' begin='" +
          (index - 1) +
          ".end' dur='" +
          pathLength / speed +
          "s' to='0' fill='freeze' />";
      }
    });
  }, [ref]);

  return (
    <div className="ClassicsTitle" ref={ref}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        id="svg1"
        width="100%"
        height="100%"
        version="1.1"
        viewBox="0 0 76.031 9.949"
        xmlSpace="preserve"
      >
        <path
          id="path5"
          fill="none"
          stroke="orange"
          strokeLinecap="round"
          strokeLinejoin="bevel"
          strokeWidth="0.3"
          d="M3.029 5.908c.135.085.182.072.342-.088.372-.372-.063-.667-.724-.492C1.354 5.671.147 6.72.147 7.5c0 .224.273.57.532.672.111.044.377.106.59.138.684.102 1.966-.074 3.308-.456.16-.045.403-.113.541-.15a43.41 43.41 0 002.11-.702c.14-.06.361-.138.765-.27"
          paintOrder="normal"
        ></path>
        <path
          id="path4"
          fill="none"
          stroke="orange"
          strokeLinecap="round"
          strokeWidth="0.3"
          d="M11.5 3.669c.034 0 .26-.15.505-.334v0C13.81 1.979 15.026.563 14.681.218c-.096-.096-.14-.096-.339.003-.963.483-3.1 2.465-4.587 6.368-.522 1.244-.548 1.868-.336 2.06.16.145.684.17 1.198.058.179-.04.534-.114.79-.165.48-.097 1.032-.24 2.398-.624.128-.036.441-.134.697-.217.255-.083.638-.203.85-.266.214-.063.893-.294 1.51-.512.617-.219 1.279-.45 1.47-.513.192-.064.427-.15.523-.19.305-.129.594-.247.773-.316l.349-.137c.724-.292.832-.318.832-.2"
        ></path>
        <path
          id="path1"
          fill="none"
          fillRule="nonzero"
          stroke="orange"
          strokeLinecap="round"
          strokeWidth="0.3"
          d="M22.291 5.274c-.074.03-.31.104-.522.165-.433.124-1.65.559-2.133.989-.606.54-.208 1.44.636 1.44.613 0 .78-.128 1.806-1.377.384-.467.54-.592.76-.662.196-.093.377.138.51.374.33.585.787 1.007 1.293 1.197.884.33 2.331.148 3.724-.47.18-.08 1.506-.821 1.535-.821"
        ></path>
        <path
          id="path40"
          fill="none"
          stroke="orange"
          strokeDasharray="none"
          strokeLinecap="round"
          strokeLinejoin="bevel"
          strokeWidth="0.3"
          d="M29.908 6.1c.423-.247 1.256-.32 1.244-.8-.013-.478-.74.032-.637.437.155.608.536 1.116.814 1.673.273.548.771 1.276.37 1.785-.464.59-1.658.945-1.99.318-.294-.556.65-.7 1.025-.72a11.516 11.516 0 002.007-.306c.892-.209 1.762-.504 2.632-.792 1.316-.437 2.69-.775 3.902-1.447.271-.15.526-.33.8-.475"
          paintOrder="normal"
        ></path>
        <path
          id="path40-4"
          fill="none"
          stroke="orange"
          strokeDasharray="none"
          strokeLinecap="round"
          strokeLinejoin="bevel"
          strokeWidth="0.3"
          d="M40.053 5.773c.43-.278 1.48-.413 1.285-.878-.115-.273-.767.035-.678.475.127.625.54 1.129.808 1.699.264.56.77 1.328.332 1.845-.476.56-1.834.922-1.99.23-.13-.578.734-.656 1.134-.683.69-.048 1.379-.143 2.046-.32.547-.146 1.081-.33 1.605-.55 2.073-.87 4.478-.92 6.33-2.3"
          paintOrder="normal"
        ></path>
        <path
          id="path10"
          fill="none"
          stroke="orange"
          strokeWidth="0.3"
          d="M51.16 4.351c-.147-.147-.109-.422.091-.655.166-.192.205-.205.387-.122.264.12.276.465.024.702-.201.188-.364.213-.502.075z"
        ></path>
        <path
          id="path2"
          fill="none"
          fillRule="nonzero"
          stroke="orange"
          strokeLinecap="round"
          strokeWidth="0.3"
          d="M50.794 5.41c.131-.124.159-.147.28-.072.16.098.045.475-.406 1.343-.601 1.156-.591 1.204.226 1.142 1.267-.097 2.192-.261 3.54-.627a74.998 74.998 0 002.36-.713c.191-.062.574-.26.851-.441.608-.398.993-.583 1.491-.714.665-.175 1.1.12.728.492"
        ></path>
        <path
          id="path1-6"
          fill="none"
          fillRule="nonzero"
          stroke="orange"
          strokeLinecap="round"
          strokeWidth="0.3"
          d="M59.786 5.745c-.103-.066-.234-.046-.342-.005-.207.08-.392.206-.573.333a5.343 5.343 0 00-.695.564c-.204.202-.403.417-.531.676-.061.122-.113.262-.086.401.019.096.095.165.177.215.165.101.362.13.553.136.253.01.507.003.76-.015a4.36 4.36 0 00.918-.179 48.95 48.95 0 001.129-.352 25.95 25.95 0 002.862-1.125c.37-.17.738-.345 1.104-.523"
        ></path>
        <path
          id="path40-4-9"
          fill="none"
          stroke="orange"
          strokeDasharray="none"
          strokeLinecap="round"
          strokeLinejoin="bevel"
          strokeWidth="0.3"
          d="M65.054 5.89c.43-.277 1.48-.412 1.284-.878-.114-.273-.767.035-.677.475.126.625.54 1.13.808 1.7.263.56.77 1.327.331 1.844-.475.561-1.834.923-1.99.23-.128-.577.735-.655 1.135-.683.69-.047 1.378-.142 2.046-.32.546-.145 1.08-.33 1.605-.55 2.073-.87 4.478-.92 6.33-2.3"
          paintOrder="normal"
        ></path>
      </svg>
    </div>
  );
}
